<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            :upload-preview="uploadPreview"
            ref="crud"
    >
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增活动', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '标题',
              prop: 'title',
              span: 24,
            }, {
              label: '公司全体入住率',
              prop: 'occupancy',
              span: 24,
            }, {
              label: '人员住宿信息查询',
              prop: 'filepaths',
              type: 'upload',
              hide: true,
              drag: true,
              dataType: 'string',
              span: 24,
              oss: 'ali', // 阿里云oss配置
            }, {
              label: '人员住宿信息查询',
              prop: 'filepaths_demo',
              type: 'string',
              formatter: function(row){
                return '<a href="' + row.filepaths + '">文件下载</a>'
              },
              display: false,
            }
          ]
        }
      }
    },
    methods: {
      uploadPreview(file,column,done){
        console.log(file.url,column);
        done(); //默认执行打开方法

        this.$notify({
          title: '操作成功!',
          dangerouslyUseHTMLString: true,
          type: 'success',
          duration: 0, // 不会自动关闭的消息
          message: '<a target="_blank" href="' + file.url + '">点我下载>>></a>'
        });
      }
    }
  }
</script>
